/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdLoadingProps } from './type';

export const loadingDefaultProps: TdLoadingProps = {
  attach: '',
  delay: 0,
  duration: 800,
  fullscreen: false,
  indicator: true,
  inheritColor: false,
  layout: 'horizontal',
  loading: true,
  pause: false,
  preventScrollThrough: true,
  size: '20px',
  theme: 'circular',
};
